export class CostDataRecordCost {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "meteringDimension",
            "baseName": "meteringDimension",
            "type": "MeteringDimension",
            "format": ""
        },
        {
            "name": "product",
            "baseName": "product",
            "type": "CostProduct",
            "format": ""
        },
        {
            "name": "usageType",
            "baseName": "usageType",
            "type": "UsageType",
            "format": ""
        },
        {
            "name": "dsgStorageTier",
            "baseName": "dsgStorageTier",
            "type": "DsgStorageTier",
            "format": ""
        },
        {
            "name": "dsgRequestType",
            "baseName": "dsgRequestType",
            "type": "DsgRequestType",
            "format": ""
        },
        {
            "name": "cost",
            "baseName": "cost",
            "type": "Cost",
            "format": ""
        },
        {
            "name": "usage",
            "baseName": "usage",
            "type": "Usage",
            "format": ""
        },
        {
            "name": "metadata",
            "baseName": "metadata",
            "type": "CostRecordMetadata",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CostDataRecordCost.attributeTypeMap;
    }
    constructor() {
    }
}
